var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapaLogoWhiteKo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 24,
    viewBox: "0 0 164 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1387_575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7896 4.8056L17.1887 8.2192C15.5488 6.03329 12.6941 5.14995 10.0976 6.01832C7.4859 6.88669 5.7397 9.2822 5.7397 12.0071C5.7397 14.732 7.4859 17.1275 10.0976 17.9809C12.7093 18.8343 15.5488 17.9509 17.1887 15.765L21.7896 19.1786C18.6768 23.3109 13.2256 25.0177 8.29067 23.3858C3.35575 21.7538 0 17.1574 0 12.0071C0 6.85675 3.34056 2.2454 8.27549 0.613457C9.50542 0.209215 10.7809 -0.000391451 12.026 -0.000391451C15.7918 -0.0153634 19.4512 1.70641 21.7896 4.8056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9299 0.330078L46.7672 23.6713H40.4353L38.9017 19.5241H29.867L28.3334 23.6713H22.0015L30.8388 0.330078H37.9299ZM31.431 14.4486H37.3377L34.3615 6.09427L31.431 14.4486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1625 0.330078L90.9998 23.6713H84.668L83.1343 19.5241H74.0997L72.566 23.6713H66.2342L75.0715 0.330078H82.1625ZM75.6636 14.4486H81.5704L78.5942 6.09427L75.6636 14.4486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.095 0.330078C60.7978 0.330078 63.2273 0.988843 65.0191 2.5609C66.8109 4.11798 67.646 6.46857 67.646 8.77424C67.646 11.0799 66.8564 13.4155 65.1254 15.0625C63.4095 16.7243 60.9193 17.5628 58.1709 17.5628H54.5267V23.6713H48.6959V0.330078H58.095ZM54.5419 11.8135H58.1861C59.8108 11.8135 60.6004 11.3943 61.0712 10.9452C61.5419 10.496 61.8304 9.85222 61.8304 8.75927C61.8304 7.65135 61.5874 7.21716 61.1623 6.84287C60.7371 6.46857 59.8564 6.06433 58.1102 6.06433H54.557V11.8135H54.5419Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1803 2.59459V3.81081H105.381C105.301 5.45946 105.006 7.08108 104.469 8.5946L95 9.2973L95.3219 10.5946L104.04 9.75676C102.484 13.2973 99.6408 16.3784 95 18.6486L95.8316 19.8378C104.094 15.7027 106.776 9.27027 106.776 2.59459H96.1803ZM112.785 0V9.86487H106.669V11.0811H112.785V23.973H114.207V0H112.785Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.518 13.7297H133.886V0.54054H132.518V5.13514H126.938V6.35135H132.518V13.7297ZM129.969 10.1351C126.724 10.7838 124.041 10.9189 121.412 10.9189H121.385V1.7027H119.964V12.1351H121.412C124.148 12.1351 126.804 12 130.157 11.3784L129.969 10.1351ZM122.78 16.5135H137.186V24H138.607V15.2973H122.78V16.5135ZM137.212 0.0270267V14H138.607V0.0270267H137.212Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.425 13.2703H146.751V8.83784H160.674V7.64865H146.751V3.43243H161.183V2.21622H145.303V14.4865H161.425V13.2703ZM142.379 19.4865V20.7027H164V19.4865H142.379Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1387_575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapaLogoWhiteKo);
export default __webpack_public_path__ + "static/media/CapaLogoWhiteKo.ab185d63.svg";
export { ForwardRef as ReactComponent };